import { defineAppConfig } from 'ice';
import aem from '@/utils/aem';
import { defineSpmConfig } from '@ali/ice-plugin-spm/types';
import { initBaxia, checkApiPath } from '@/utils/baxia';

// Baxia 初始化（应用启动时立即执行，确保在请求发出前完成初始化）
initBaxia(
  {
    checkApiPath,
    appendTo: 'header',
  },
  () => {
    console.log('Baxia 初始化完成！');
  },
);

// 修复：如果 search 为空或没有多个问号时不处理，且兼容 hash、search 为空等情况
const checkSearch = () => {
  const { search } = window.location;
  if (!search) return;
  // 检查是否存在多个问号（即至少两个）
  const qCount = (search.match(/\?/g) || []).length;
  if (qCount >= 2) {
    // 只保留第一个问号，其余全部替换为 &
    const firstQuestionIndex = search.indexOf('?');
    const firstPart = search.slice(0, firstQuestionIndex + 1);
    const restPart = search.slice(firstQuestionIndex + 1).replace(/\?/g, '&');
    const newSearch = firstPart + restPart;
    const newUrl = window.location.origin + window.location.pathname + newSearch + window.location.hash;
    window.history.replaceState(null, '', newUrl);
  }
};
checkSearch();

window.onload = () => {
  aem();
};
function setRem() {
  const baseFontSize = 16;
  let screenWidth = document.documentElement.clientWidth || document.body.clientWidth;
  let scale;

  if (screenWidth >= 1680) {
    scale = screenWidth / (1680 / baseFontSize);
  } else if (screenWidth >= 1024 && screenWidth < 1680) {
    scale = baseFontSize;
  } else if (screenWidth <= 1024 && screenWidth >= 768) {
    scale = screenWidth / (1024 / (baseFontSize * 1.2));
  } else {
    scale = screenWidth / (768 / (baseFontSize * 1.5));
  }

  const htmlDom = document.getElementsByTagName('html')[0];
  htmlDom.style.fontSize = `${scale}px`;
}

// 初始化
setRem();
// 改变窗口大小时重新设置 rem
window.onresize = function () {
  setRem();
};

/**
 * @description 应用配置
 */
export default defineAppConfig(() => ({
  app: {
    rootId: 'app-container',
    errorBoundary: true,
  },
  router: {
    type: 'browser',
  },
}));

export const spmConfig = defineSpmConfig(() => {
  return {
    spmA: 'a2c_o01',
  };
});
